import { actions, types } from './requests'
export const GETCLIENTORDERTYPELIST_TYPES = {
    ...types('GETCLIENTORDERTYPELIST'),
}
export const GETCLIENTORDERTYPELIST_ACTIONS = {
    ...actions('GETCLIENTORDERTYPELIST'),
}
